import { createJsonAdapter } from './jsonAdapter';

export interface IMedicationRow {
  id: string;
  name: string;
  purpose?: string | null;
  dosage?: string | null;
  frequency?: string | null;
  howToTake?: string | null;
}

const str = (value: unknown) => String(value ?? '').trim();

export const medicationAdapter = createJsonAdapter<IMedicationRow>({
  url: 'medications',
  rowToForm: (row) => ({
    name: row.name ?? '',
    purpose: row.purpose ?? '',
    dosage: row.dosage ?? '',
    frequency: row.frequency ?? '',
    howToTake: row.howToTake ?? '',
  }),
  toBody: (form) => ({
    name: str(form.name),
    purpose: str(form.purpose),
    dosage: str(form.dosage),
    frequency: str(form.frequency),
    howToTake: str(form.howToTake),
  }),
});
